// packages/shared-utils/src/schema/debug.schema.ts
//
// Payloads for the development debug cheats (grant an item def, roll a loot table).
// These endpoints are gated on `cheatsAllowed` server-side and hidden behind the
// client's cheat toggle, but they are permanent tools — not scaffolding.
import { z } from 'zod';
import { GameStateDeltaSchema } from './game.schema.js';
import { PendingLootSchema } from './loot.schema.js';
/** One selectable entry in the debug catalog (an item def or a loot table). */
export const DebugCatalogEntrySchema = z.object({
    id: z.string(),
    name: z.string(),
});
export const DebugCatalogRequestSchema = z.object({
    gameId: z.string(),
});
export const DebugCatalogResponseSchema = z.object({
    items: z.array(DebugCatalogEntrySchema),
    lootTables: z.array(DebugCatalogEntrySchema),
});
export const DebugGrantItemRequestSchema = z.object({
    gameId: z.string(),
    defId: z.string(),
});
export const DebugGrantItemResponseSchema = z.object({
    stateDelta: GameStateDeltaSchema,
    grantedName: z.string(),
});
export const DebugGrantLootRequestSchema = z.object({
    gameId: z.string(),
    tableId: z.string(),
});
export const DebugGrantLootResponseSchema = z.object({
    stateDelta: GameStateDeltaSchema,
    pendingLoot: PendingLootSchema,
});
